import React, { useState } from "react";
import Breadcrumb from "../../../Components/Common/Breadcrumb";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import Table from "../../../Components/Common/Table";
import useSWR from "swr";
import { subTopicUrls } from "../../../Api/Auth/ApiUrls";
import QueryString from "qs";
import useTable from "../../../hooks/useTable";
import TableHead from "../../../Components/Common/TableHead";
import { Loader } from "../../../Components/Common/Loader";
import NoData from "../../../Components/Common/NoData";
import SubTopicRow from "./Components/SubTopicRow";
import Pagination from "../../../Components/Common/Pagination/Pagination";
import { useLocation } from "react-router-dom";
import Modal from "../../../Components/Common/Modal";
import useToastError from "../../../hooks/useErrorToast";
import useSWRMutation from "swr/mutation";
import {
  sendPostRequestAuth,
  sendPutRequestAuth,
} from "../../../Api/swrConfig";
import { toast } from "react-toastify";
import SubTopicForm from "./Components/SubTopicForm";
import Storage from "../Storage";
import Tabs from "../../../Components/Common/Tabs";
import { practiceHubTabsData } from "../../../data/SidebarData";

const tableColumnData = [
  { id: "title", label: "Title" },
  { id: "link", label: "Link" },
  { id: "createdAt", label: "Created" },
];

const SubTopicAdmin = () => {
  const [row, setRow] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    link: "",
  });
  const [errors, setErrors] = useState({});
  const { showErrorToast } = useToastError();
  const [isStorageModalOpen, setStorageModalOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const location = useLocation();

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    useTable({ defaultOrderBy: "" });

  const apiQueryParams = {
    offset: (page - 1) * rowsPerPage,
    limit: rowsPerPage,
  };
  const apiQueryString = QueryString.stringify(apiQueryParams);

  const { isLoading, data, mutate } = useSWR(subTopicUrls.list(apiQueryString));

  const handleInputChange = (name, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: value, // Set only the field that's changed
    }));
  };

  const onEditClick = (row) => {
    setRow(row);
    handleInputChange("title", row.title);
    handleInputChange("link", row.link);
    setModalOpen(true);
  };

  const { trigger, isMutating } = useSWRMutation(
    subTopicUrls.create,
    sendPostRequestAuth,
    {
      onSuccess: (data) => {
        toast.success("Success");
        mutate();
        setModalOpen(false);
      },
      onError: (error) => {
        showErrorToast(error);
      },
    }
  );
  const { trigger: EditTrigger, isMutating: editMutating } = useSWRMutation(
    subTopicUrls.edit(row?._id),
    sendPutRequestAuth,
    {
      onSuccess: (data) => {
        toast.success("Success");
        mutate();
        setModalOpen(false);
      },
      onError: (error) => {
        showErrorToast(error);
      },
    }
  );

  const actionButtons = [
    {
      label: "Create",
      icon: faAdd,
      onClick: () => {
        setRow(null);
        setFormData({
          title: "",
          link: "",
        });
        setModalOpen(true);
      },
    },
  ];

  const validateForm = () => {
    const newErrors = {};
    if (!formData.title) newErrors.title = "Title is required";
    if (!formData.link) newErrors.link = "File is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    row ? EditTrigger(formData) : trigger(formData);
  };

  return (
    <div>
      <Breadcrumb actionButtons={actionButtons} />
      <Tabs tabs={practiceHubTabsData} />

      <Table>
        <TableHead rowCount={data?.data.length} headerData={tableColumnData} />
        <tbody className={`divide-y divide-gray-200`}>
          {!isLoading ? (
            <>
              {data?.data.map((row) => (
                <SubTopicRow
                  key={row._id}
                  row={row}
                  mutate={mutate}
                  onEditClick={onEditClick}
                />
              ))}
            </>
          ) : (
            <tr>
              <td colSpan="100" className="text-center py-4">
                <Loader />
              </td>
            </tr>
          )}
        </tbody>
        <NoData isNotFound={!data?.data.length && !isLoading} />
      </Table>
      <Pagination
        totalRows={data?.pagination.totalItems || 0}
        currentPage={page}
        rowsPerPage={rowsPerPage}
        currentPath={location.pathname}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Modal
        isOpen={isModalOpen}
        title={row ? "Edit Sub Topic" : "Create Sub Topic"}
        onConfirm={handleSubmit}
        onCancel={() => {
          setErrors({});
          setModalOpen(false);
        }}
        isLoading={isMutating || editMutating}
        formWidth
      >
        <SubTopicForm
          errors={errors}
          handleSubmit={handleSubmit}
          onChange={handleInputChange}
          formData={formData}
          setModalOpen={setStorageModalOpen}
        />
      </Modal>
      <Modal
        isOpen={isStorageModalOpen}
        title={"Storage Manager"}
        // onConfirm={handleSubmit}
        onCancel={() => {
          setStorageModalOpen(false);
        }}
        footer={false}
      >
        <Storage
          isSelector
          onConfirm={(file) => {
            if (Array.isArray(file) && file.length)
              handleInputChange(
                "link",
                file?.map((item) => item.fileUrl)
              );
            setStorageModalOpen(false);
          }}
          multiple
        />
      </Modal>
    </div>
  );
};

export default SubTopicAdmin;
